import { Col, Row, Form, FloatingLabel, Button } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import { Link, useNavigate,useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { FaAddressCard } from "react-icons/fa";
import { BsCreditCard2BackFill } from "react-icons/bs";
import { TbBuildingFactory } from "react-icons/tb";
import { useAxios } from "../../../context/AxiosProvider";
import { useValidation } from "../../../context/ValidationContext";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import axios from "axios";

export default function EditBrickKiln() {
  const { id } = useParams();
  const { validateImageDimensions, validateCnic, formatCnic } = useValidation();
  const [searchValue, setSearchValue] = useState(""); // State for the input value
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
  const [data, setData] = useState([]);
  const [brickkilnData, setBrickkilnData] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [error, setError] = useState({});
  const [dynamicTitle, setDynamicTitle] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const axiosInstance = useAxios();

  const tehsils = [
  { id: 1, name: "Tehsil 1" },
  { id: 2, name: "Tehsil 2" },
  { id: 3, name: "Tehsil 3" },
  { id: 4, name: "Tehsil 4" },
];

  // States to hold the file objects and their previews
  const [formState, setFormState] = useState({
    cnic_picture_front: { file: null, preview: null },
    cnic_picture_back: { file: null, preview: null },
    brickkiln_name:null,
    year_of_op:null,
    registered:null,
    brickkiln_owner:null,
    city_id:null,
    lat:null,
    long:null,
    owner_cnic:null,
    brickkiln_owner_cell:null,
    munshi_name:null,
    munshi_cnic:null,
    munshi_contact:null,
    address:null,
    union_council:0,
    union_council_number:0,
    tehsil:0,
    pin_location:null,
    brickkiln_name: null,
    owner_cnic: null,
    designation_id: 0,
    brick_kiln_pic: { file: null, preview: null },
  });

  //Handling cities Search
  const handleSearch = (value) => {
    setSearchValue(value); // Update the input value
    if (value.trim() === "") {
      setFilteredCities([]); // Clear suggestions if input is empty
    } else {
      const filtered = data?.cities?.filter((city) =>
        city.name.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredCities(filtered);
    }
  };

  // Fetch initial data for designations and cities
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_API_URL + "/edit-brickkiln/"+id
        );
        setData(response.data);
        setFormState((prevState) => ({
          ...prevState,
          cnic_picture_front: { file: null, preview: null,imgsrc:response.data.brickkiln?.cnic_picture_front}  ,
          cnic_picture_back: { file: null, preview: null,imgsrc:response.data.brickkiln?.cnic_picture_back },
          brickkiln_owner: response.data.brickkiln?.brickkiln_owner,
          brickkiln_owner_cell: response.data.brickkiln?.brickkiln_owner_cell,
          registered:response.data.brickkiln?.registered,
          long:response.data.brickkiln?.long,
          lat:response.data.brickkiln?.lat,
          union_council:response.data.brickkiln?.union_council,
          year_of_op:response.data.brickkiln?.year_of_op,
          brickkiln_name: response.data.brickkiln?.brickkiln_name,
          brickkiln_owner:response.data.brickkiln?.brickkiln_owner,
          brickkiln_owner_cell:response.data.brickkiln?.brickkiln_owner_cell,
          owner_cnic: response.data.brickkiln?.owner_cnic,
          designation_id: response.data.brickkiln?.designation_id,
          city_id:response.data.brickkiln?.city_id ,
          address: response.data.brickkiln?.address,
          tehsil:response.data.brickkiln?.tehsil,
          pin_location:response.data.brickkiln?.pin_location,
          brick_kiln_pic: { file: null, preview: null,imgsrc:response.data.brickkiln?.brick_kiln_pic },
        }));
        setDynamicTitle(response.data.brickkiln?.designation?.name)
        handleSearch( response.data.brickkiln?.city?.name)
        console.log(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // Handle file input change and validation
  const handleFileChange = async (e, fieldName, width, height) => {
    const file = e.target.files[0];
    if (file) {
      try {
        // Validate and resize the image
        const resizedImage = await validateImageDimensions(file, width, height);
        const previewUrl = URL.createObjectURL(resizedImage);

        setFormState((prevState) => ({
          ...prevState,
          [fieldName]: {
            file: resizedImage,
            preview: previewUrl,
          },
        }));
        setError(""); // Clear any previous errors
      } catch (err) {
        setError("Invalid image file or dimensions.");
      }
    }
  };

  const handleChange = (e) => {
    const { name, value, type, files, } = e.target;
    let selectedOption = "";
    if (type === "select-one") { // Ensure it's a <select> element
      if (e.target.selectedIndex === -1 || value === "") {
        console.log("No option selected");
      } else {
        selectedOption = e.target.options[e.target.selectedIndex];
        console.log("Selected Option Value:", selectedOption.value);
        console.log("Selected Option InnerHTML:", selectedOption.innerHTML);
      }
    }
    // Handle file input
    if (type === "file") {
      const file = files[0];
      const previewUrl = file ? URL.createObjectURL(file) : null;

      setFormState((prevState) => ({
        ...prevState,
        [name]: {
          file,
          preview: previewUrl,
        },
      }));
    } else {
      // Handle regular input fields
      setFormState((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }

    if (name === "designation_id" && value != "") {
      setDynamicTitle(selectedOption?.innerHTML);
      return;
    }

    // Handle CNIC field
    if (name === "owner_cnic") {
      const formattedCnic = formatCnic(value); // Format CNIC input
      setFormState((prevState) => ({
        ...prevState,
        owner_cnic: formattedCnic, // Update formatted CNIC in the form state
      }));

      // Validate CNIC
      setError((prevError) => ({
        ...prevError,
        owner_cnic: validateCnic(formattedCnic) ? "" : "Invalid CNIC", // Set error if CNIC is invalid
      }));
    }

    if (name === "city_id") {
      handleSearch(value);
    }
  };
  const unionCouncils = [
  { id: 1, name: "Union Council 1" },
  { id: 2, name: "Union Council 2" },
  { id: 3, name: "Union Council 3" },
  { id: 4, name: "Union Council 4" },
];


  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formState, 'formState')
    const isValid = checkFields();
    if (!isValid) {
      return;
    }
    setIsSubmitting(true);
    const formData = new FormData();

    // Loop over formState and append each field to the FormData object
    for (const key in formState) {
      const value = formState[key];

      if (value && value.file) {
        // If it's a file (e.g., images), append it
        formData.append(key, value.file);
      } else {
        // If it's a regular text input, append it directly
        formData.append(key, value);
      }
    }
    storeData(formData);
  };

  const checkFields = () => {
    const {
      
      brickkiln_owner,
      brickkiln_owner_cell,
      brickkiln_name,
      owner_cnic,
      designation_id,
      city_id,
      address,
      } = formState;

    const newError = {}; // Initialize an empty error object

    // Check for empty text fields and update error state
    if (!brickkiln_owner) {
      newError.brickkiln_owner = `Brickkiln ${dynamicTitle}  is required.`;
    }
    if (!brickkiln_owner_cell) {
      newError.brickkiln_owner_cell = `Brickkiln ${dynamicTitle} cell is required.`;
    }
    if (!brickkiln_name) {
      newError.brickkiln_name = "Brickkiln name is required.";
    }
    if (!owner_cnic) {
      newError.owner_cnic = "CNIC is required.";
    }
    if (!designation_id || designation_id === "") {
      newError.designation = "Designation is required.";
    }
    if (!city_id) {
      newError.city = "City is required.";
    }
    if (!address) {
      newError.address = "Address is required.";
    }

   

    // If there are errors, update the error state and return false
    if (Object.keys(newError).length > 0) {
      setError((prevError) => ({
        ...prevError,
        ...newError, // Merge existing errors with new errors
      }));

      setTimeout(() => {
        setError({});
      }, 5000);
      return false;
    }

    // All validations passed, clear error state
    setError({});
    return true;
  };

  const storeData = async (formData) => {
    try {
      // Make the POST request
      const response = await axios.post(process.env.REACT_APP_API_URL+"/update-brickkiln/"+id, formData);

      // Success handling
      Swal.fire({
        title: 'Success!',
        text: 'Brick Kiln Updated successfully.',
        icon: 'success',
        confirmButtonText: 'Ok',
      });
      navigate('/all-brickkiln')
    } catch (error) {
      setIsSubmitting(false);
      // Validation error handling (status 422)
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        const errorList = Object.values(errors)
          .flat() // Flatten nested arrays
          .map((err) => `<li>${err}</li>`) // Convert each error into an HTML list item
          .join(''); // Join all list items

        Swal.fire({
          title: 'Please fix the following errors!',
          html: `<ul>${errorList}</ul>`,
          icon: 'error',
          confirmButtonText: 'Ok',
          customClass: {
            popup: 'text-left', // Align text to the left for better readability
          },
        });
      } else {
        // Generic error handling
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong. Please try again.',
          icon: 'error',
          confirmButtonText: 'Ok',
        });
      }
    }
  };


  const getDesignationID = (id) => {
    setFormState((prevState) => ({
      ...prevState,
      designation_id: id,
    }));
  };

  const handleRemoveImage = () => {
    setFormState((prevState) => ({
      ...prevState,
      brick_kiln_pic: {
        ...prevState.brick_kiln_pic,
        preview: null, // Reset preview image
      },
    }));
    // Optionally, you can also reset the file input to clear the file itself
    document.querySelector("input[name='brick_kiln_pic']").value = "";
  };

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">
                <i className="material-icons">factory</i>
                Edit Brick Kiln
              </h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="/" className="mc-breadcrumb-link">
                    Home
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">Edit New Brick Kiln</li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
         <Form.Group as={Col} md="4" className="mb-3">
          <FloatingLabel label="Designation">
            <Form.Select
              required
              placeholder="Designation"
              name="designation_id"
              value={formState.designation_id}
              onChange={handleChange}
            >
              <option value={""}>Select...</option>
              {data?.designations?.map((designation) => (
                <option
                  key={designation.id}
                  value={designation.id}
                >
                  {designation.name}
                </option>
              ))}
            </Form.Select>
          </FloatingLabel>
          {error.designation && (
            <div className="text-danger text-center">{error.designation}</div>
          )}
        </Form.Group>


{formState.designation_id === "1" && ( // assuming id 1 = Owner
  <>
    <Form.Group as={Col} md="4" className="mb-3">
      <FloatingLabel label="Owner Name">
        <Form.Control
          type="text"
          placeholder="Owner Name"
          required
          name="brickkiln_owner"
          value={formState.brickkiln_owner}
          onChange={handleChange}
        />
      </FloatingLabel>
      {error.brickkiln_owner && (
        <div className="text-danger text-center">{error.brickkiln_owner}</div>
      )}
    </Form.Group>

    <Form.Group as={Col} md="4" className="mb-3">
      <FloatingLabel label="Owner CNIC Number">
        <Form.Control
          type="text"
          placeholder="Owner CNIC Number"
          required
          name="owner_cnic"
          value={formState.owner_cnic}
          onChange={handleChange}
        />
      </FloatingLabel>
      {error.owner_cnic && (
        <div className="text-danger text-center">{error.owner_cnic}</div>
      )}
    </Form.Group>

    <Form.Group as={Col} md="4" className="mb-3">
      <FloatingLabel label="Owner Contact Number">
        <Form.Control
          type="number"
          placeholder="Owner Contact Number"
          required
          name="brickkiln_owner_cell"
          value={formState.brickkiln_owner_cell}
          onChange={handleChange}
        />
      </FloatingLabel>
      {error.brickkiln_owner_cell && (
        <div className="text-danger text-center">{error.brickkiln_owner_cell}</div>
      )}
    </Form.Group>
  </>
)}

{formState.designation_id === "2" && ( 
  <>
    <Form.Group as={Col} md="4" className="mb-3">
      <FloatingLabel label="Munshi Name">
        <Form.Control
          type="text"
          placeholder="Munshi Name"
          required
          name="munshi_name"
          value={formState.munshi_name}
          onChange={handleChange}
        />
      </FloatingLabel>
      {error.munshi_name && (
        <div className="text-danger text-center">{error.munshi_name}</div>
      )}
    </Form.Group>

    <Form.Group as={Col} md="4" className="mb-3">
      <FloatingLabel label="Munshi CNIC Number">
        <Form.Control
          type="number"
          placeholder="Munshi CNIC Number"
          required
          name="munshi_cnic"
          value={formState.munshi_cnic}
          onChange={handleChange}
        />
      </FloatingLabel>
      {error.munshi_cnic && (
        <div className="text-danger text-center">{error.munshi_cnic}</div>
      )}
    </Form.Group>

    <Form.Group as={Col} md="4" className="mb-3">
      <FloatingLabel label="Munshi Contact Number">
        <Form.Control
          type="number"
          placeholder="Munshi Contact Number"
          required
          name="munshi_contact"
          value={formState.munshi_contact}
          onChange={handleChange}
        />
      </FloatingLabel>
      {error.munshi_contact && (
        <div className="text-danger text-center">{error.munshi_contact}</div>
      )}
    </Form.Group>
  </>
)}

        <Form.Group as={Col} md="4" className="mb-3">
          <FloatingLabel label="Brick Kiln Name">
            <Form.Control
              type="text"
              placeholder="Brick Kiln Name"
              required
              name="brickkiln_name"
              value={formState.brickkiln_name}
              onChange={handleChange}
            />
          </FloatingLabel>
          {error.brickkiln_name && (
            <div className="text-danger text-center">
              {error.brickkiln_name}
            </div>
          )}
        </Form.Group>

        <Form.Group as={Col} md="4" className="mb-3">
          <FloatingLabel label={`Brick Kiln ${dynamicTitle} Name`}>
            <Form.Control
              type="text"
              placeholder={`Brick Kiln ${dynamicTitle} Name`}
              required
              name="brickkiln_owner"
              value={formState.brickkiln_owner}
              onChange={handleChange}
            />
          </FloatingLabel>
          {error.brickkiln_owner && (
            <div className="text-danger text-center">
              {error.brickkiln_owner}
            </div>
          )}
        </Form.Group>

        <Form.Group as={Col} md="4" className="mb-3">
          <FloatingLabel label={`Brick Kiln ${dynamicTitle} Cell No`}>
            <Form.Control
              type="text"
              required
              placeholder="Brick Kiln Owner Cell No"
              name="brickkiln_owner_cell"
              value={formState.brickkiln_owner_cell}
              onChange={handleChange}
            />
          </FloatingLabel>
          {error.brickkiln_owner_cell && (
            <div className="text-danger text-center">
              {error.brickkiln_owner_cell}
            </div>
          )}
        </Form.Group>

        <Form.Group as={Col} md="4" className="mb-3">
          <FloatingLabel label="CNIC">
            <Form.Control
              type="text"
              placeholder="CNIC"
              required
              name="owner_cnic"
              value={formState.owner_cnic}
              onChange={handleChange}
            />
          </FloatingLabel>
          {error.owner_cnic && (
            <div className="text-danger text-center">{error.owner_cnic}</div>
          )}
        </Form.Group>

        <Form.Group as={Col} md="4" className="mb-3" style={{ position: "relative" }}>
          <FloatingLabel label="City">
            <Form.Control
              type="text"
              placeholder="Enter City"
              value={searchValue} // Use the search value to display what the user types
              onChange={(e) => {
                handleSearch(e.target.value); // Update search
                setFormState((prevState) => ({
                  ...prevState,
                  city_id: "", // Clear city_id while typing
                }));
              }}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setTimeout(() => setIsFocused(false), 150)} // Delay hiding dropdown
              name="city_id"
            />

          </FloatingLabel>

          {isFocused && (
            <ul
              style={{
                position: "absolute",
                top: "100%",
                left: "0",
                right: "0",
                background: "#fff",
                border: "1px solid #ddd",
                zIndex: 1000,
                maxHeight: "150px",
                overflowY: "auto",
                listStyleType: "none",
                padding: "0",
                margin: "0",
              }}
            >
              {filteredCities?.length > 0 ? (
                filteredCities.map((city) => (
                  <li
                    key={city.id}
                    onClick={() => {
                      setSearchValue(city.name); // Set the city name as input value
                      setFormState((prevState) => ({
                        ...prevState,
                        city_id: city.id, // Store city ID in the state
                      }));
                      setIsFocused(false); // Close dropdown after selection
                    }}
                    style={{
                      padding: "10px",
                      cursor: "pointer",
                      borderBottom: "1px solid #eee",
                    }}
                  >
                    {city.name}
                  </li>
                ))
              ) : (
                <li
                  style={{
                    padding: "10px",
                    cursor: "default",
                    textAlign: "center",
                    color: "#888",
                  }}
                >
                  No city with this name
                </li>
              )}
            </ul>
          )}
          {error.city && (
            <div className="text-danger text-center">{error.city}</div>
          )}
        </Form.Group>

        <Form.Group as={Col} md="4" className="mb-3">
  <FloatingLabel label="Address of Brick Kiln">
    <Form.Control
      as="textarea"
      rows={4}
      placeholder="Plot Number or Village/Town/City"
      required
      name="address"
      value={formState.address}
      onChange={handleChange}
    />
  </FloatingLabel>
  {error.address && (
    <div className="text-danger text-center">{error.address}</div>
  )}
</Form.Group>
 <Form.Group as={Col} md="4" className="mb-3">
  <FloatingLabel label="Years of Operations">
    <Form.Control
      type="number"
      placeholder="Years of Operations"
      required
      name="year_of_op"
      value={formState.year_of_op}
      onChange={handleChange}
    />
  </FloatingLabel>
  {error.year_of_op && (
    <div className="text-danger text-center">{error.year_of_op}</div>
  )}
</Form.Group>

<Form.Group as={Col} md="4" className="mb-3">
  <FloatingLabel label="union council">
    <Form.Control
      type="text"
      placeholder="union council"
      required
      name="union_council"
      value={formState.union_council}
      onChange={handleChange}
    />
  </FloatingLabel>
  {error.union_council && (
    <div className="text-danger text-center">{error.union_council}</div>
  )}
</Form.Group>


        <Form.Group as={Col} md="4" className="mb-3">
          <FloatingLabel label="Latitude">
            <Form.Control
              type="text"
              placeholder="latitude"
              required
              name="lat"
              value={formState.lat}
              onChange={handleChange}
            />
          </FloatingLabel>
          {error.lat && (
            <div className="text-danger text-center">{error.lat}</div>
          )}
        </Form.Group>
        
        <Form.Group as={Col} md="4" className="mb-3">
          <FloatingLabel label="Longitude">
            <Form.Control
              type="text"
              placeholder="longitude"
              required
              name="long"
              value={formState.long}
              onChange={handleChange}
            />
          </FloatingLabel>
          {error.long && (
            <div className="text-danger text-center">{error.long}</div>
          )}
        </Form.Group>
        
          
          
        <Row>
          <Col xl={5}>
            <Col xl={12} style={{ cursor: "pointer" }}>
              <div className="mc-card" style={{ position: "relative" }}>
                <Form.Group>
                  <Form.Label
                    style={{
                      width: "100%",
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {!formState.cnic_picture_front.preview && !formState.cnic_picture_front.imgsrc? (
                      <>
                        {"Add Brick Kilns Owner's CNIC Front"}
                        <i
                          style={{
                            color: "#1976D2",
                            cursor: "pointer",
                            fontSize: "4rem",
                          }}
                          className="material-icons"
                        >
                          <FaAddressCard />
                        </i>
                        <span
                          className="text-danger"
                          style={{
                            fontSize: "10px",
                            position: "absolute",
                            right: "15px",
                            bottom: "15px",
                          }}
                        >
                          Size Should be 500 x 200
                        </span>
                      </>
                    ) : (
                      <img
                        src={formState.cnic_picture_front.preview || process.env.REACT_APP_IMG_URL+ formState.cnic_picture_front.imgsrc }
                        alt="CNIC Front Preview"
                        style={{
                          width: "100%",
                          height: "auto",
                          borderRadius: "10px",
                          objectFit: "cover",
                          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                          border: "2px solid #1976D2",
                          padding: "5px",
                        }}
                      />
                    )}
                    <Form.Control
                      type="file"
                      hidden
                      name="cnic_picture_front"
                      placeholder="Front Pic of CNIC"
                      onChange={(e) =>
                        handleFileChange(e, "cnic_picture_front", 500, 200)
                      }
                    />
                  </Form.Label>
                </Form.Group>
              </div>
              {error.cnic_picture_front && (
                <div className="text-danger text-center">
                  {error.cnic_picture_front}
                </div>
              )}
            </Col>

            <Col xl={12} style={{ cursor: "pointer" }}>
              <div className="mc-card" style={{ position: "relative" }}>
                <Form.Group>
                  <Form.Label
                    style={{
                      width: "100%",
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {!formState.cnic_picture_back.preview && !formState.cnic_picture_back.imgsrc ? (
                      <>
                        {"Add Back of CNIC"}
                        <i
                          style={{
                            color: "#1976D2",
                            cursor: "pointer",
                            fontSize: "4rem",
                          }}
                          className="material-icons"
                        >
                          <BsCreditCard2BackFill />
                        </i>
                        <span
                          className="text-danger"
                          style={{
                            fontSize: "10px",
                            position: "absolute",
                            right: "15px",
                            bottom: "15px",
                          }}
                        >
                          Size Should be 500 x 200
                        </span>
                      </>
                    ) : (
                      <img
                        src={formState.cnic_picture_back.preview || process.env.REACT_APP_IMG_URL+ formState.cnic_picture_back.imgsrc}
                        alt="CNIC Back Preview"
                        style={{
                          width: "100%",
                          height: "auto",
                          borderRadius: "10px",
                          objectFit: "cover",
                          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                          border: "2px solid #1976D2",
                          padding: "5px",
                        }}
                      />
                    )}
                    <Form.Control
                      type="file"
                      hidden
                      name="cnic_picture_back"
                      placeholder="Back Pic of CNIC"
                      onChange={(e) =>
                        handleFileChange(e, "cnic_picture_back", 500, 200)
                      }
                    />
                  </Form.Label>
                </Form.Group>
              </div>
              {error.cnic_picture_back && (
                <div className="text-danger text-center">
                  {error.cnic_picture_back}
                </div>
              )}
            </Col>
          </Col>

          <Col xl={7}>
            <Form.Group as={Col} md="12" className="mb-3">
              <div
                className="mc-card"
                style={{
                  position: "relative",
                  overflow: "hidden",
                  height: "320px",
                  width: "550px",
                }}
              >
                <Form.Label
                  style={{
                    width: "100%",
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {!formState.brick_kiln_pic.preview && !formState.brick_kiln_pic.imgsrc ? (
                    <>
                      {"Add Pic of Brick Kiln"}
                      <i
                        style={{
                          color: "#1976D2",
                          cursor: "pointer",
                          fontSize: "11rem",
                          textAlign: "center",
                        }}
                        className="material-icons"
                      >
                        <TbBuildingFactory />
                      </i>
                      <span
                        className="text-danger"
                        style={{
                          fontSize: "10px",
                          position: "absolute",
                          right: "15px",
                          bottom: "15px",
                        }}
                      >
                        Size Should be 500 x 270
                      </span>
                    </>
                  ) : (
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                      }}
                    >
                      <img
                        src={formState.brick_kiln_pic.preview || process.env.REACT_APP_IMG_URL+ formState.brick_kiln_pic.imgsrc}
                        alt="Brick Kiln Preview"
                        style={{
                          width: "100%",
                          height: "auto",
                          borderRadius: "10px",
                          objectFit: "cover",
                          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                          border: "2px solid #1976D2",
                          padding: "5px",
                        }}
                      />
                      {/* <div
                        type="button"
                        onClick={handleRemoveImage}
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                          backgroundColor: "red",
                          color: "white",
                          border: "none",
                          borderRadius: "50%",
                          padding: "5px 8px",
                          fontSize: "16px",
                          cursor: "pointer",
                        }}
                      >
                        X
                      </div> */}
                    </div>
                  )}
                  <Form.Control
                    type="file"
                    required
                    hidden
                    name="brick_kiln_pic"
                    placeholder="Add Brick Kiln Pic"
                    onChange={(e) =>
                      handleFileChange(e, "brick_kiln_pic", 500, 270)
                    }
                  />
                </Form.Label>
              </div>
              {error.brick_kiln_pic && (
                <div className="text-danger text-center">
                  {error.brick_kiln_pic}
                </div>
              )}
            </Form.Group>
          </Col>
        </Row>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <Button
            as={Col}
            md="3"
            variant="success"
            type="Update"
            onClick={handleSubmit}
            disabled={isSubmitting} // Disable button if isSubmitting is true
          >
            {isSubmitting ? "Updating..." : "Update"} {/* Show dynamic button text */}
          </Button>
        </div>
      </Row>
    </PageLayout>
  );
}
